import React from 'react';
import ProductHeroSection from '../Components/Product/ProductHeroSection.jsx';
import ProductGallery from '../Components/Product/ProductGallery.jsx';
import ProductFeatures from '../Components/Product/ProductFeatures.jsx';
import ProductDescription from '../Components/Product/ProductDescription.jsx';

const ProductPage = () => {
  return (
    <main role="main">
      <ProductHeroSection />
      <ProductGallery />
      <ProductFeatures />
      <ProductDescription />
    </main>
  );
};

export default ProductPage;
